import { useTranslation } from "react-i18next";
import { Flex } from "@mantine/core";
import { StarsRating } from "@testuj.to/react";
import dayjs from "dayjs";

import { useOverviewStatistics } from "../../../../hooks/overview";
import { StatisticCard } from "./card";

export const StatisticsWidget = () => {
    const { t } = useTranslation(["common"]);
    const { currentlyTested, averageRating, reviewsCount, testsCount } = useOverviewStatistics();
    return (
        <Flex gap={16} wrap="wrap">
            <StatisticCard
                title={t("dashboard_card_currently_testing")}
                subTitle={`${t("dashboard_card_year")} ${dayjs().format("YYYY")}`}
                value={currentlyTested}
            />
            <StatisticCard
                title={t("dashboard_card_testing_count")}
                subTitle={t("dashboard_card_overall")}
                value={testsCount}
            />
            <StatisticCard
                title={t("dashboard_card_reviews_count")}
                subTitle={t("dashboard_card_overall")}
                value={reviewsCount}
            />
            <StatisticCard
                title={t("dashboard_card_average_rating")}
                subTitle={t("dashboard_card_overall")}
                value={averageRating}
                minWidth={270}
                subComponent={<StarsRating readOnly rating={averageRating} />}
            />
        </Flex>
    );
};
